import { reduxForm } from 'redux-form';
import generatorNeedsFormConfig from './configs/generator-needs-form-config';

export default reduxForm(generatorNeedsFormConfig);



// WEBPACK FOOTER //
// ./src/views/Home/components/withReduxFormGeneratorNeedsConfig.js